import React from 'react';

// Indicador único de la parte administrativa (Inspecciones, Reportes,
// Estado): cifra grande + etiqueta, ícono opcional. tono: neutral | falla |
// alerta | exito | aviso (los colores son tokens de estado de VLS).
const TONO = {
  neutral: { icono: 'bg-primary/10 text-primary', valor: 'text-foreground' },
  falla: { icono: 'bg-error/10 text-error', valor: 'text-error' },
  alerta: { icono: 'bg-warning/15 text-warning-foreground', valor: 'text-warning-foreground' },
  exito: { icono: 'bg-success/10 text-success', valor: 'text-success' },
};

export default function Kpi({ icon: Icon, label, value, tono = 'neutral' }) {
  const t = TONO[tono] || TONO.neutral;
  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-3" data-testid="kpi">
      {Icon && (
        <div className={`hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl sm:flex ${t.icono}`}>
          <Icon size={18} strokeWidth={2.25} aria-hidden="true" />
        </div>
      )}
      <div className="min-w-0">
        <div className={`text-2xl font-bold leading-none tabular-nums ${t.valor}`}>{value}</div>
        <div className="mt-1 text-xs font-medium leading-tight text-muted-foreground">{label}</div>
      </div>
    </div>
  );
}
